/* HD filter bar, v73. Sizes the Juicy Filters sort <select> to the option
   that is selected, for browsers without CSS field-sizing (Safari, Firefox).
   Upload as assets/hd-filterbar.js and load with
   <script src="{{ 'hd-filterbar.js' | asset_url }}" defer></script>
   on collection and search templates. Safe to load everywhere: it does
   nothing if the app's select is not on the page. */
(function () {
  if (window.CSS && CSS.supports && CSS.supports("field-sizing", "content")) return;
  var canvas = document.createElement("canvas"), ctx = canvas.getContext("2d");
  function fit(sel) {
    if (!sel || !sel.options.length) return;
    var cs = getComputedStyle(sel);
    ctx.font = cs.fontWeight + " " + cs.fontSize + " " + cs.fontFamily;
    var text = (sel.options[sel.selectedIndex] || sel.options[0]).text;
    var w = Math.ceil(ctx.measureText(text).width) + 22;   /* + arrow room */
    sel.style.width = Math.min(w, 190) + "px";
  }
  function run() {
    var sel = document.getElementById("tpss-sort-select");
    if (!sel) return;
    fit(sel);
    if (!sel.dataset.hdFit) {
      sel.dataset.hdFit = "1";
      sel.addEventListener("change", function () { fit(sel); });
    }
  }
  /* The app renders after load and re-renders on filter changes */
  var t;
  new MutationObserver(function () { clearTimeout(t); t = setTimeout(run, 60); })
    .observe(document.documentElement, { childList: true, subtree: true });
  if (document.readyState !== "loading") run();
  else document.addEventListener("DOMContentLoaded", run);
})();
